import React from "react";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";
import { object, shape, string } from "prop-types";

import {
  ConfirmationWrapper,
  ModalHeading,
  ModalIconWrapper,
  ModalText,
  ModalTitle
} from "../../../../styled";

const AccountCreatedConfirmation = props => (
  <ConfirmationWrapper>
    <ModalIconWrapper>
      <FontAwesomeIcon color="primary" fontSize="33px" iconClass="checkmark" />
    </ModalIconWrapper>
    <ModalHeading scenario={props.scenario}>
      <ModalTitle scenario={props.scenario} type="primarySm">
        You shared this {props.data.sharedType}
      </ModalTitle>
    </ModalHeading>
    <ModalText>{props.data.confirmationText}</ModalText>
  </ConfirmationWrapper>
);

AccountCreatedConfirmation.propTypes = {
  data: shape({
    confirmationText: object.isRequired,
    sharedType: string.isRequired
  }).isRequired,
  scenario: string.isRequired
};

export default AccountCreatedConfirmation;
